'use client'

import { useState, useEffect } from 'react'
import { Sparkles } from 'lucide-react'
import { QuickCaptureModal } from './quick-capture-modal'

/**
 * Global Quick Capture entry point: a header button + a "c" keyboard shortcut
 * (ignored while typing in a field). Self-contained - owns the modal state.
 */
export function QuickCaptureTrigger() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key !== 'c' || e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return
      const t = e.target as HTMLElement | null
      const tag = t?.tagName
      if (tag === 'INPUT' || tag === 'TEXTAREA' || t?.isContentEditable) return
      e.preventDefault()
      setOpen(true)
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [])

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Quick capture (shortcut: c)"
        title="Quick capture (c)"
        className="inline-flex items-center gap-1.5 rounded-[var(--radius-md)] border border-[var(--color-border-default)] bg-[var(--color-bg-surface)] px-2.5 py-1.5 text-[var(--text-xs)] font-semibold text-[var(--color-text-secondary)] transition-colors hover:border-[var(--color-brand-indigo)] hover:text-[var(--color-text-primary)]"
      >
        <Sparkles className="h-4 w-4" aria-hidden="true" />
        <span className="hidden md:inline">Capture</span>
      </button>
      <QuickCaptureModal open={open} onClose={() => setOpen(false)} />
    </>
  )
}
